import { apiTask } from 'app/sagas';
import { api } from 'app/api';
import { take, fork, all, takeLatest, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as actions from './registerActions';

/**
 * Tasks
 */

export const registerUserTask = apiTask(
  actions.REGISTER_USER,
  api.post,
  '/planner-plans/registerUser.php',
);

export const getSchoolsTask = apiTask(
  actions.GET_SCHOOLS,
  api.get,
  '/planner-plans/getSchoolsList.php',
);

export const getSchoolDetailsTask = apiTask(
  actions.GET_SCHOOL_DETAILS,
  api.post,
  '/planner-plans/getSchoolDetail.php',
);

export const getCountries = apiTask(actions.COUNTRIES, api.post, '/planner-plans/getCountries.php');

export function* searchSchoolTask({ payload }) {
  yield delay(500);
  const task = apiTask(actions.SEARCH_SCHOOLS, api.post, '/planner-plans/schoolSearch.php');
  yield call(task, payload);
}

export const getStatesTask = apiTask(
  actions.GET_STATES,
  api.post,
  '/planner-plans/schoolSearch.php',
);

export const getCitiesTask = apiTask(
  actions.GET_CITIES,
  api.post,
  '/planner-plans/schoolSearch.php',
);

/**
 * Watchers
 */
export function* watchGetSchools() {
  while (yield take(actions.GET_SCHOOLS)) {
    yield fork(getSchoolsTask);
  }
}

export function* watchGetSchoolDetails() {
  while (true) {
    const { payload } = yield take(actions.GET_SCHOOL_DETAILS);
    yield fork(getSchoolDetailsTask, payload);
  }
}

export function* watchGetStates() {
  while (true) {
    const { payload } = yield take(actions.GET_STATES);
    yield fork(getStatesTask, payload);
  }
}

export function* watchSchoolSearch() {
  yield takeLatest(actions.SEARCH_SCHOOLS, searchSchoolTask);
}

export function* watchGetCities() {
  while (true) {
    const { payload } = yield take(actions.GET_CITIES);
    yield fork(getCitiesTask, payload);
  }
}

export function* watchRegisterUser() {
  while (true) {
    const { payload } = yield take(actions.REGISTER_USER);
    yield fork(registerUserTask, payload);
  }
}

export function* watchGetCountries() {
  while (true) {
    const { payload } = yield take(actions.COUNTRIES);
    yield fork(getCountries, payload);
  }
}

export function* sagas(): Iterable<T> {
  yield all([
    fork(watchGetSchools),
    fork(watchGetSchoolDetails),
    fork(watchRegisterUser),
    fork(watchGetStates),
    fork(watchGetCities),
    fork(watchSchoolSearch),
    fork(watchGetCountries),
  ]);
}
